'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventImage = function (_Component) {
  (0, _inherits3.default)(EventImage, _Component);

  function EventImage() {
    (0, _classCallCheck3.default)(this, EventImage);
    return (0, _possibleConstructorReturn3.default)(this, (EventImage.__proto__ || (0, _getPrototypeOf2.default)(EventImage)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventImage, [{
    key: 'render',
    value: function render() {
      if (this.props.src) {
        return _react2.default.createElement(
          'div',
          { className: 'EventImage' },
          _react2.default.createElement('img', { src: this.props.src, alt: '' })
        );
      }
      return null;
    }
  }]);
  return EventImage;
}(_react.Component);

EventImage.propTypes = {
  /**
   * The URL to the image.
   */
  src: _propTypes2.default.string
};
exports.default = EventImage;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventImage.js
// module id = 269
// module chunks = 0